module.exports = __webpack_public_path__ + "static/img/bg_mobile.19fae794.webp";